/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Route } from 'router5';

export enum RouteId {
    Main = 'main', //document picture screen

    Login = 'login',
    InspectorLogin = 'login.inspector',
    OperatorLogin = 'login.operator',
    TaxpayerLogin = 'login.taxpayer',

    System = 'system',
    SystemSettings = 'system.settings',
    SystemSettingsInfo = 'system.settings.info',
    SystemSettingsSecurity = 'system.settings.security',
    SystemAdmin = 'system.admin',
    SystemAdminUsers = 'system.admin.users',

    Monitoring = 'monitoring',
    Home = 'monitoring.home',
    HomeOperator = 'monitoring.home-operator',
    HomeTaxpayer = 'monitoring.home-taxpayer',

    Infographic = 'monitoring.infographic',
    InfographicFin = 'monitoring.infographic.fin',
    InfographicTech = 'monitoring.infographic.tech',
    InfographicRegional = 'monitoring.infographic.regional',
    InfographicCentral = 'monitoring.infographic.central',

    Statistics = 'monitoring.statistics',

    Alerts = 'monitoring.alerts',
    AlertsList = 'monitoring.alerts.list',
    AlertCard = 'monitoring.alerts.card',
    AlertsSettings = 'monitoring.alerts.settings',
    AlertLogs = 'monitoring.alerts.logs',
    AlertRules = 'monitoring.alerts.rules',

    Reports = 'monitoring.reports',

    Map = 'monitoring.map',
    MapStores = 'monitoring.map.stores',
    MapCashboxes = 'monitoring.map.cashboxes',

    Registry = 'monitoring.registry',
    RegistryOperators = 'monitoring.registry.operators',
    RegistryOperatorsList = 'monitoring.registry.operators.list',
    RegistryOperatorCard = 'monitoring.registry.operators.card',
    RegistryCompanies = 'monitoring.registry.companies',
    RegistryCompaniesList = 'monitoring.registry.companies.list',
    RegistryCompanyCard = 'monitoring.registry.companies.card',
    RegistryStores = 'monitoring.registry.stores',
    RegistryStoresList = 'monitoring.registry.stores.list',
    RegistryStoreCard = 'monitoring.registry.stores.card',
    RegistryCashboxes = 'monitoring.registry.cashboxes',
    RegistryCashboxesList = 'monitoring.registry.cashboxes.list',
    RegistryCashboxCard = 'monitoring.registry.cashboxes.card',
    RegistryDocuments = 'monitoring.registry.documents',
    RegistryDocumentsList = 'monitoring.registry.documents.list',
    RegistryDocumentCard = 'monitoring.registry.documents.card',
    RegistryDocumentCardPict = 'monitoring.registry.documents.card-pict',
    RegistryDevices = 'monitoring.registry.devices',
    RegistryDevicesList = 'monitoring.registry.devices.list',
    RegistryDeviceCard = 'monitoring.registry.devices.card',

    RegistryCashRegisterModels = 'monitoring.registry.cashRegisterModels',
    RegistryCashRegisterModelsList = 'monitoring.registry.cashRegisterModels.list',
    RegistryCashRegisterModelCard = 'monitoring.registry.cashRegisterModels.card',

    RegistryCashRegister = 'monitoring.registry.cashRegister',
    RegistryCashRegistersList = 'monitoring.registry.cashRegister.list',
    RegistryCashRegisterCard = 'monitoring.registry.cashRegister.card',

    Service = 'monitoring.service',
}

export enum RouteParam {
    AlertId = 'AlertId',
    CompanyTaxNumber = 'CompanyTaxNumber',
    OperatorTaxNumber = 'OperatorTaxNumber',
    StoreTaxNumber = 'StoreTaxNumber',
    CashboxTaxNumber = 'CashboxTaxNumber',
    CashRegisterModelTaxNumber = 'CashRegisterModelTaxNumber',
    CashRegisterFactoryNumber = 'CashRegisterFactoryNumber',
    AlertTemplateId = 'AlertTemplateId',
    AlertTemplateName = 'AlertTemplateName',
    AlertEntityType = 'AlertEntityType',
    //don't rename this param value
    DocumentId = 'doc',
    DocumentIdHash = 'DocumentIdHash',
    DeviceFactoryNumber = 'DeviceFactoryNumber',
    CreatedAtUtc = 'CreatedAtUtc',
}

export const routes: Route[] = [
    { name: RouteId.Main, path: `/index?${RouteParam.DocumentId}` },

    { name: RouteId.Login, path: '/login' },
    { name: RouteId.InspectorLogin, path: '/inspector' },
    { name: RouteId.OperatorLogin, path: '/operator' },
    { name: RouteId.TaxpayerLogin, path: '/taxpayer' },

    { name: RouteId.System, path: '/system' },
    { name: RouteId.SystemSettings, path: '/settings', forwardTo: RouteId.SystemSettingsInfo },
    { name: RouteId.SystemSettingsInfo, path: '/info' },
    { name: RouteId.SystemSettingsSecurity, path: '/security' },
    { name: RouteId.SystemAdmin, path: '/admin', forwardTo: RouteId.SystemAdminUsers },
    { name: RouteId.SystemAdminUsers, path: '/users' },

    { name: RouteId.Monitoring, path: '/monitoring' },
    { name: RouteId.Home, path: '/home' },
    { name: RouteId.HomeOperator, path: '/home-operator' },
    { name: RouteId.HomeTaxpayer, path: '/home-taxpayer' },

    { name: RouteId.Infographic, path: '/infographic' },
    { name: RouteId.InfographicFin, path: '/fin' },
    { name: RouteId.InfographicTech, path: '/tech' },
    { name: RouteId.InfographicCentral, path: '/central' },
    { name: RouteId.InfographicRegional, path: '/regional' },

    { name: RouteId.Statistics, path: '/statistics' },

    { name: RouteId.Alerts, path: '/alerts', forwardTo: RouteId.AlertsList },
    { name: RouteId.AlertsList, path: '/list' },
    { name: RouteId.AlertCard, path: `/card/:${RouteParam.AlertId}` },
    { name: RouteId.AlertsSettings, path: '/settings' },
    { name: RouteId.AlertLogs, path: `/logs/:${RouteParam.AlertTemplateId}` },
    { name: RouteId.AlertRules, path: `/rules/:${RouteParam.AlertTemplateName}/:${RouteParam.AlertEntityType}` },

    { name: RouteId.Reports, path: '/reports' },

    { name: RouteId.Map, path: '/map' },
    { name: RouteId.MapStores, path: '/stores' },
    { name: RouteId.MapCashboxes, path: '/cashboxes' },

    { name: RouteId.Registry, path: '/registry' },
    { name: RouteId.RegistryOperators, path: '/operators', forwardTo: RouteId.RegistryOperatorsList },
    { name: RouteId.RegistryOperatorsList, path: '/list' },
    { name: RouteId.RegistryOperatorCard, path: `/card/:${RouteParam.OperatorTaxNumber}` },
    { name: RouteId.RegistryCompanies, path: '/companies', forwardTo: RouteId.RegistryCompaniesList },
    { name: RouteId.RegistryCompaniesList, path: '/list' },
    { name: RouteId.RegistryCompanyCard, path: `/card/:${RouteParam.CompanyTaxNumber}` },
    { name: RouteId.RegistryStores, path: '/stores', forwardTo: RouteId.RegistryStoresList },
    { name: RouteId.RegistryStoresList, path: '/list' },
    { name: RouteId.RegistryStoreCard, path: `/card/:${RouteParam.StoreTaxNumber}` },
    { name: RouteId.RegistryCashboxes, path: '/cashboxes', forwardTo: RouteId.RegistryCashboxesList },
    { name: RouteId.RegistryCashboxesList, path: '/list' },
    { name: RouteId.RegistryCashboxCard, path: `/card/:${RouteParam.CashboxTaxNumber}` },
    { name: RouteId.RegistryDocuments, path: '/documents', forwardTo: RouteId.RegistryDocumentsList },
    { name: RouteId.RegistryDocumentsList, path: '/list' },
    { name: RouteId.RegistryDocumentCard, path: `/card/:${RouteParam.DocumentId}` },
    {
        name: RouteId.RegistryDocumentCardPict,
        path: `/card-pict/:${RouteParam.CashboxTaxNumber}/:${RouteParam.CreatedAtUtc}/:${RouteParam.DocumentIdHash}`,
    },
    { name: RouteId.RegistryDevices, path: '/devices', forwardTo: RouteId.RegistryDevicesList },
    { name: RouteId.RegistryDevicesList, path: '/list' },
    { name: RouteId.RegistryDeviceCard, path: `/card/:${RouteParam.DeviceFactoryNumber}` },

    {
        name: RouteId.RegistryCashRegisterModels,
        path: '/cashRegisterModels',
        forwardTo: RouteId.RegistryCashRegisterModelsList,
    },
    { name: RouteId.RegistryCashRegisterModelsList, path: '/list' },
    { name: RouteId.RegistryCashRegisterModelCard, path: `/card/:${RouteParam.CashRegisterModelTaxNumber}` },

    {
        name: RouteId.RegistryCashRegister,
        path: '/cashRegister',
        forwardTo: RouteId.RegistryCashRegistersList,
    },
    { name: RouteId.RegistryCashRegistersList, path: '/list' },
    { name: RouteId.RegistryCashRegisterCard, path: `/card/:${RouteParam.CashRegisterFactoryNumber}` },

    { name: RouteId.Service, path: '/service' },
];
